import { get, post, throwIfError } from 'utils/api';

export const getAffordableApplicationAdditionalDetails = async ({
  organizationId,
  propertyId,
  portalUserId,
  householdId,
  applicationId,
  applicantId,
  options,
} = {}) => {
  const paramValues = {
    applicationId,
    applicantId,
    householdId,
    portalUserId,
  };

  // remove undefined values
  Object.keys(paramValues).forEach(
    (key) => !Boolean(paramValues[key]?.length) && delete paramValues[key],
  );

  const params = new URLSearchParams(paramValues);

  const url = `/${organizationId}/${propertyId}/affordable-application-additional-details?${params}`;

  let response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  const parseJSON = (data) => {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.error(e);
      }
    }

    return data;
  };

  response = response.map((details) => {
    details.assets = parseJSON(details.assets);
    details.incomes = parseJSON(details.incomes);
    details.household = parseJSON(details.household);

    return details;
  });

  return response;
};

export const createOrUpdateAffordableApplicationAdditionalDetails = async ({
  organizationId,
  propertyId,
  payload,
  options,
}) => {
  const url = `/${organizationId}/${propertyId}/affordable-application-additional-details`;
  const response = await post(url, payload, options);

  return throwIfError(response);
};
